export {OpponentZoneSlot} from './ZoneSlot.Opponent'